// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"218":"3c39aef3","241":"5bc7f3e6","266":"8c6eb3df","719":"ca2540af","868":"502d99f5"}[chunkId] + ".chunk.css";
};